import Select, { useGetSelectOptions } from './DisplayAsSelect';

export default Select;

export { useGetSelectOptions };
